module.exports = __webpack_public_path__ + "images/花筑奢pr长图_03.jpg?v=c37b7b96";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_03.jpg
 ** module id = 29
 ** module chunks = 1 2
 **/